/**
 * @name 上传组件
 */
import base from '../../base';
import Upload from './Upload';

Upload.install = function(Vue) {
  Vue.use(base);
  Vue.component(Upload.name, Upload);
};

export default Upload;
